/**
 * Mapping from breakpoint to number of cards to display on Modal.
 */
export const MODAL_INITIAL_COUNTS = {
  0: 1,
  1: 2,
  2: 2,
  3: 2,
  4: 2,
} as const

/**
 * Mapping from breakpoint to number of cards to display on Screen.
 */
export const SCREEN_INITIAL_COUNTS = {
  0: 1,
  1: 2,
  2: 2,
  3: 2,
  4: 2,
} as const
